import React from 'react';
import { ChakraV3 } from '..';

export interface SegmentedControlProps extends Omit<ChakraV3.SegmentGroup.RootProps, 'onChange'> {
  options: {
    value: string;
    label: string;
    icon?: React.ReactElement;
  }[];
  value?: string;
  onChange: (value: string) => void;
}

export const SegmentGroup = React.forwardRef<HTMLDivElement, SegmentedControlProps>(
  (props, ref) => {
    const { onChange, options, value, disabled, ...rest } = props;

    return (
      <ChakraV3.SegmentGroup.Root
        ref={ref}
        value={value}
        onValueChange={(details) => details.value && onChange(details.value)}
        disabled={disabled}
        size='sm'
        {...rest}
      >
        <ChakraV3.SegmentGroup.Indicator />
        {options.map((option) => (
          <ChakraV3.SegmentGroup.Item key={option.value} value={option.value}>
            {option.icon && <ChakraV3.Icon size='sm'>{option.icon}</ChakraV3.Icon>}
            <ChakraV3.SegmentGroup.ItemText>{option.label}</ChakraV3.SegmentGroup.ItemText>
            <ChakraV3.SegmentGroup.ItemHiddenInput />
          </ChakraV3.SegmentGroup.Item>
        ))}
      </ChakraV3.SegmentGroup.Root>
    );
  },
);
